<template>
  <v-dialog v-model="show" v-bind="$attrs" v-on="$listeners">
   <v-card variant="outlined">
    <slot name="toolbar">
      <v-toolbar
        color="pageHeader"
        height="48"
      >
      <v-toolbar-title class="text-subtitle-2">
        <slot name="title">
          Title
        </slot>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="title-close">
        <v-icon right @click="close()">mdi-close</v-icon>
      </slot>
      </v-toolbar>
      </slot>
      <v-card-text class="pa-4">
        <slot></slot>
      </v-card-text>
      <slot name="action">
        <v-card-actions class="justify-end">
          <a-btn
            color="secondary"
            @click="close()"
          >Close</a-btn>
          <a-btn
              color="primaryDark"
              @click="close()"
            >Save</a-btn>
        </v-card-actions>
      </slot>
    </v-card>
  </v-dialog>
</template>

<script>
import ABtn from "./ABtn.vue";
export default {
  name: "CDialog",
  components: { ABtn },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  }
};
</script>

<style scoped>
.v-sheet.v-toolbar.pageHeader{
  box-shadow: none
}
</style>